// Store
import { Action, Selector, State, StateContext } from '@ngxs/store';
// Action
import {
	SaveFilterForm,
	SelectedOrderID,
	SelectedRowOrder,
} from './action/inbox.action';
// Models
import { InboxStateModel } from './model/inbox-state.model';
import { Logout } from '@cv-invision/core';
import { OrderInboxModel } from '../model/order-inbox.model';
import { Injectable } from '@angular/core';

@State<InboxStateModel>({
	name: 'inbox',
	defaults: {}
})
@Injectable()
export class InboxState {
	constructor() {
		//
	}

	/**
	 * Get Inbox State Model.
	 * @param state: InboxStateModel
	 */
	@Selector()
	static getInbox(state: InboxStateModel): InboxStateModel {
		return state;
	}

	/**
	 * Get Inbox selected order id value.
	 * @param state: InboxStateModel
	 */
	@Selector()
	static getSelectedOrderId(state: InboxStateModel): number {
		return state.selectedOrderRow;
	}

	/**
	 * Get Inbox selected order .
	 * @param state: InboxStateModel
	 */
	@Selector()
	static getSelectedOrder(state: InboxStateModel): OrderInboxModel {
		return null; // state.selectedOrderInboxModel;
	}

	/**
	 * Get Inbox selected order .
	 * @param state: InboxStateModel
	 */
	@Selector()
	static getSelectedOrderState(state: InboxStateModel): string {
		return null; // state.selectedOrderInboxModel.stateEnum;
	}

	/**
	 * Returns all selected clients from the filter form.
	 */
	@Selector()
	static selectedTrackingClients(state: InboxStateModel) {
		return state.inboxFilterForm?.trackingClients;
	}

	/**
	 * Save the current values of the Inbox Filter
	 * @param ctx
	 * @param payload
	 */
	@Action(SaveFilterForm)
	saveFilterForm(ctx: StateContext<InboxStateModel>, { payload }: SaveFilterForm): any {
		const state = ctx.getState();
		ctx.patchState({
			...state,
			inboxFilterForm: payload
		});
	}

	/**
	 * Save the current selected inbox Order
	 * @param ctx
	 * @param payload
	 */
	@Action(SelectedOrderID)
	setSelectedOrder(ctx: StateContext<InboxStateModel>, { orderId }: SelectedOrderID): any {
		const state = ctx.getState();
		ctx.patchState({
			...state,
			selectedOrderRow: orderId
		});
	}

	/**
	 * Save the current selected Row Order
	 * @param ctx
	 * @param payload
	 */
	@Action(SelectedRowOrder)
	selectedRowOrder(ctx: StateContext<InboxStateModel>, { payload }: SelectedRowOrder): any {
		const state = ctx.getState();
		ctx.patchState({
			...state,
			selectedOrderRow: payload
		});
	}

	/**
	 * Logout.
	 * @param ctx: InboxStateModel
	 */
	@Action(Logout)
	logout(ctx: StateContext<InboxStateModel>): void {
		ctx.setState({});
	}
}
